module.exports = __webpack_public_path__ + "img/logo.a9f46a57.jpeg";